import moment from "moment";
import { createDynamicThunk } from ".";
import { store } from "..";

export const getExpenseRequestsListThunk = createDynamicThunk({
  typePrefix: "expense/getExpenseRequestsListThunk",
  useHandleSearch: true,
  
});

export const getListOfExpenseListThunk = createDynamicThunk({
  typePrefix: "listOfExpenses/getListOfExpenseListThunk",
  useHandleSearch: true,

  // custom transformation of HandleSearch result
  transformResponse: (result, payload) => {
    const { name, status, onFilteredData } = payload;
    const authList = store.getState().auth.list;

    // Get correct dataset based on name
    let expenseInfo = [];
    if (name === "dashboardPendingRequest") {
      expenseInfo =
        authList[process.env.REACT_APP_DASHBOARD_PR_SEARCH_IN + "_info"] || [];
    } else if (name === "dashboardListOfExpense") {
      expenseInfo =
        authList[process.env.REACT_APP_DASHBOARD_EL_SEARCH_IN + "_info"] || [];
    } else {
      expenseInfo = authList[payload.route + "_info"] || [];
    }

    // Apply your filtering conditions
    const pendingStatus =
      process.env.REACT_APP_TAB_PAYMENT_PENDING_STATUS.toUpperCase();
    const myRequests = process.env.REACT_APP_MY_REQUESTS.toUpperCase();

    const filteredData =
      status === "ALL" ||
      status.includes(pendingStatus) ||
      status.includes(myRequests)
        ? expenseInfo
        : expenseInfo.filter((item) =>
            status.includes(item.status?.toUpperCase())
          );

    // Pass filtered data back to UI callback
    if (onFilteredData) onFilteredData(filteredData);

    // Return transformed response to store
    return {
      data: filteredData,
      pagination: result.pagination,
      totalCount: result.totalCount,
    };
  },
});

export const getListOfExpenseDetailThunk = createDynamicThunk({
  typePrefix: "listOfExpense/getListOfExpenseDetailThunk",
  endpoint: "/list-of-expense",
  method: "GET",
  refreshList: false,
});

export const updateListOfExpenseThunk = createDynamicThunk({
  typePrefix: "listOfExpense/updateListOfExpenseThunk",
  endpoint: "/list-of-expense",
  method: "PUT",
  refreshList: true,
});

export const searchExpenseDataThunk = createDynamicThunk({
  typePrefix: "expenseMultitasking/searchExpenseData",
  endpoint: "/search", // backend search endpoint
  method: "POST",
  refreshList: false, // will refresh projectCodes.list in slice
  listThunk: getListOfExpenseDetailThunk,
  transformResponse: (response) => {
    if (!response?.response) {
      return { list: [], totalCount: 0 };
    }
    
    return {
      list: response.response.map((records) => ({
        key: records?._id,
        empName: records?.empName,
        empID: records?.empID,
        businessPurpose: records?.businessPurpose,
        natureOfExpense: records?.natureOfExpense || "-",
        projectCodeID: records?.projectCodeID
          ? records.projectCodeID
          : "N/A",
        departmentID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.departmentID || null
            : "-",
        expenseCodeID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.expenseCodeID || null
            : "-",
        currencyID:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.currencyID || null
            : "-",
        cost:
          records?.expensesDetails && records?.expensesDetails.length === 1
            ? records.expensesDetails[records.expensesDetails.length - 1]
                ?.cost || null
            : "-",
        totalReimbursement: records?.totalReimbursement,
        approvers: records?.approvers,
        adminApprover:
          records.status ===
            process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
          records?.adminApprover?.[0]?.status ===
            process.env.REACT_APP_SENTBACK_STATUS.toUpperCase() &&
          records?.adminApprover?.[0]?.reason
            ? process.env.REACT_APP_SENTBACK_STATUS
            : records?.adminApprover?.[0]?.status ===
              process.env.REACT_APP_APPROVED_STATUS.toUpperCase()
            ? process.env.REACT_APP_APPROVED_STATUS
            : records?.adminApprover?.[0]?.status ===
                process.env.REACT_APP_CANCELED_STATUS.toUpperCase() &&
              records?.adminApprover?.[0]?.reason
            ? process.env.REACT_APP_CANCELED_STATUS
            : process.env.REACT_APP_PENDING_STATUS,
        expensePeriod:
          records?.expensePeriodFromDate && records?.expensePeriodToDate
            ? moment(records.expensePeriodFromDate).format("Do MMM, YYYY") +
              " - " +
              moment(records.expensePeriodToDate).format("Do MMM, YYYY")
            : "",
        month: records?.expensePeriodFromDate
          ? moment(records.expensePeriodFromDate).format("MMM")
          : "",
        expensePeriodFromDate: records?.expensePeriodFromDate
          ? moment(records.expensePeriodFromDate).format("DD-MM-YY")
          : "",
        onBehalfApprovers: records?.onBehalfApprovers || null,
        children:
                  records?.expensesDetails && records?.expensesDetails.length > 1
                    ? records.expensesDetails.map((item, index) => ({
                        key: item._id || index,
                        date: item?.date ? moment(item.date).format("DD-MM-YYYY") : "-",
                        description: item?.description || "-",
                        departmentID: item?.departmentID || "-",
                        expenseCodeID: item?.expenseCodeID || "-",
                        currencyID: item?.currencyID || "-",
                        cost: item?.cost || "-",
                      }))
                    : null,
        paymentPaidOn: records?.paymentPaidOn || null,
        modeOfPayment: records?.modeOfPayment || null,
        status: records?.history?.[records.history.length - 1]?.status,
      })),
      totalCount: response.totalCount || 0,
    };
  },
});
